/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'whatwg-fetch';
import {
  trimStart,
  trimEnd,
  forOwn,
  has,
  isNull,
} from 'lodash';
import config from 'loracfg';
import { getAuthCookies } from '../cookies/auth';
import { parseAPIError } from './error';

// Fetches an API response.
export function callAPI(request) {
  const apiRoot = trimEnd(config.apiBase, '/ ');
  const {
    endpoint,
    method = 'GET',
    query,
    body,
  } = request;

  let fullUrl;
  if (endpoint.indexOf('http') !== 0) {
    const path = trimStart(endpoint, ' /');
    fullUrl = `${apiRoot}/${path}`;
  } else {
    fullUrl = endpoint;
  }

  if (query) {
    let queryStr = '';
    let joint = '';
    forOwn(query, (v, k) => {
      if (!_.isNil(v)) {
        queryStr += `${joint}${k}=${encodeURIComponent(v)}`;
        joint = '&';
      }
    });
    if (fullUrl.indexOf('&') >= 0) {
      fullUrl = `${fullUrl}&${queryStr}`;
    } else {
      fullUrl = `${fullUrl}?${queryStr}`;
    }
  }

  const init = {
    method,
    credentials: 'include',
  };

  const authCookies = getAuthCookies();
  if (authCookies) {
    init.headers = {
      Authorization: `Bearer ${authCookies.access_token}`,
    };
  }

  if (body) {
    init.body = JSON.stringify(body);
  }

  return fetch(fullUrl, init).then(response =>
    response.json().then((json) => {
      if (!response.ok) {
        throw json;
      }
      if (has(json, 'list') && isNull(json.list)) {
        return { ...json, list: [] };
      }
      return json;
    })
  ).catch((error) => {
    throw parseAPIError(error);
  });
}




// WEBPACK FOOTER //
// ./src/utils/api/index.js